import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "avatar-icon",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.iconClasses),
      style: _normalizeStyle(_ctx.iconStyle)
    }, null, 6)
  ], 4))
}